import React, { useEffect, useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { FiAlignRight, FiXCircle, FiChevronDown } from "react-icons/fi";
import "./NavBar.css";
import { baseUrl } from "../Constant";
import axios from "axios";

const MenuNavBar = () => {
  const [isMenu, setisMenu] = useState(false);
  const [isResponsiveclose, setResponsiveclose] = useState(false);
  const toggleClass = () => {
    setisMenu(isMenu === false ? true : false);
    setResponsiveclose(isResponsiveclose === false ? true : false);
  };
  let boxClass = ["main-menu"];
  if (isMenu) {
    boxClass.push("menuq2");
  } else {
    boxClass.push("");
  }

  const [temp,setTemp]  = useState("")
  useEffect(()=>{
    const homeUrl = async()=>{
    const result = await axios.get(`${baseUrl}/homeUrl`)
    const {data:{Url}} = result
    setTemp(Url)
    }
    homeUrl();
  },[])
  const isStaging =
    process.env.NODE_ENV === "production" &&
    window.location.hostname.includes("staging");

  const BASE_URL = isStaging
    ? "https://atci.lkm.delivery.staging.accenture.com"
    : "https://atci.lkm.delivery.accenture.com";

  return (
    <div className="header__middle">
      <div className="head-container">
        <div className="header__middle__menus">
          <nav className="main-nav ">
            {/* Responsive Menu Button */}
            {isResponsiveclose === true ? (
              <>
                <span
                  className="menubar__button"
                  style={{ display: "none" }}
                  onClick={toggleClass}
                >
                  {" "}
                  <FiXCircle />{" "}
                </span>
              </>
            ) : (
              <>
                <span
                  className="menubar__button"
                  style={{ display: "none" }}
                  onClick={toggleClass}
                >
                  {" "}
                  <FiAlignRight />{" "}
                </span>
              </>
            )}
            <ul className={boxClass.join(" ")}>
              <li className="menu-item">
                <a
                  onClick={toggleClass}
                  activeClassName="is-active"
                  className="nav-links"
                  href={temp?temp:""}
                >
                  L&TT Home
                </a>
              </li>
              <li className="menu-item">
                <NavLink
                  onClick={toggleClass}
                  activeClassName="is-active"
                  className="nav-links"
                  to="/home"
                  exact
                >
                  Home
                </NavLink>
              </li>
              <li className="menu-item">
                <a
                  href={`${BASE_URL}/leadershipprograms/home`}
                  activeClassName="is-active"
                  className="nav-links"
                  onClick={toggleClass}
                  target="_blank"
                >
                  Leadership Programs
                </a>
              </li>
              <li className="menu-item">
                <a
                  href={`${BASE_URL}/Agile`}
                  activeClassName="is-active"
                  className="nav-links"
                  onClick={toggleClass}
                  target="_blank"
                >
                  Agile
                </a>
              </li>
              <li className="menu-item">
                <a
                  href={`${BASE_URL}/DevOps`}
                  activeClassName="is-active"
                  className="nav-links"
                  onClick={toggleClass}
                  target="_blank"
                >
                  DevOps
                </a>
              </li>
              <li className="menu-item">
                <a
                  href={`${BASE_URL}/TT/home`}
                  activeClassName="is-active"
                  className="nav-links"
                  onClick={toggleClass}
                  target="_blank"
                >
                  IE
                </a>
              </li>
              <li className="menu-item">
                <a
                  href={`${BASE_URL}/TechCore/home`}
                  activeClassName="is-active"
                  className="nav-links"
                  onClick={toggleClass}
                  target="_blank"
                >
                  Tech Core
                </a>
              </li>
              <li className="menu-item">
                <a
                  href={`${BASE_URL}/SRE`}
                  activeClassName="is-active"
                  className="nav-links"
                  onClick={toggleClass}
                  target="_blank"
                >
                  SRE
                </a>
              </li>
              <li className="menu-item">
                <a
                  href={`${BASE_URL}/DLF/`}
                  activeClassName="is-active"
                  className="nav-links"
                  onClick={toggleClass}
                  target="_blank"
                >
                  DFA
                </a>
              </li>
              <li className="menu-item">
                <a
                  href={`${BASE_URL}/SystemIntegration/`}
                  activeClassName="is-active"
                  className="nav-links"
                  onClick={toggleClass}
                  target="_blank"
                >
                  SI
                </a>
              </li>
              <li className="menu-item">
                <a
                  href={`${BASE_URL}/ApplicationManagementServices/home`}
                  activeClassName="is-active"
                  className="nav-links"
                  onClick={toggleClass}
                  target="_blank"
                >
                  AMS
                </a>
              </li>

              <li className="menu-item">
                <a
                  href={`${BASE_URL}/ProjectManagement/`}
                  activeClassName="is-active"
                  className="nav-links"
                  onClick={toggleClass}
                  target="_blank"
                >
                  PM
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default MenuNavBar;
